<template>
<v-card flat >
  <client-list
    v-model="recipient"
    :show-list-initially="false"
    :with-action="false"
    :with-create="false"
    @relationshipselected="setRelationship" />

  <!-- <pre v-text="selectedRelationship" /> -->
  <!-- <pre v-text="payload" class="caption" /> -->
  <!-- <pre v-text="recipient" class="caption" /> -->
  <template  v-if="recipient" >
    <v-chip outline
      v-if="recipient.phone_number"
      @click="activeTab=0"
      class="v-chip--x-small ml-2" color="primary" >{{recipient.phone_number}}</v-chip>
    <v-chip outline
      v-if="recipient.email"
      @click="activeTab=1"
      class="v-chip--x-small ml-2" color="primary" >{{recipient.email}}</v-chip>

    <v-tabs v-if="recipientId" v-model='activeTab' >
      <v-tab :disabled='!recipient.phone_number' >Short message</v-tab>
      <v-tab :disabled='!recipient.email' >Email</v-tab>
      <v-tabs-items v-model='activeTab' >
        <v-tab-item >

          <v-textarea box
            label="short message"
            v-model="shortMessage"
            counter="140" />

        </v-tab-item>
        <v-tab-item >
          <v-text-field label="subject" v-model="subject" />
          <v-textarea box label="message" v-model="message" />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
    <v-card-actions >
      <v-spacer />
      <v-btn @click="send"
        color="primary"
        :loading="request.loading" >Send</v-btn>
    </v-card-actions>
  </template>
</v-card>
</template>
<script>
import ClientList from '@/components/client/ClientList.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'Compose',
  components: {ClientList},
  data () {
    return {
      activeTab: 0,
      selectedRelationship: {},
      subject: '',
      message: '',
      shortMessage: '',
      request: {
        resource: 'unibox.comms',
        extra: 'send'
      }
    }
  },
  methods: {
    send () {
      this.request.data = this.payload
      this.$request('save', this.request)
    },
    setRelationship (rel) {
      this.selectedRelationship = rel
    }
  },
  computed: {
    ...mapGetters(['me']),
    recipientId () {
      return this.getObjectPath(this.selectedRelationship, 'id')
    },
    messageType () {
      if (this.activeTab === 0) {
        return 'SMS'
      }
      if (this.activeTab === 1) {
        return 'Email'
      }
    },
    sender () {
      return {
        id: this.me.id,
        first_name: this.me.first_name,
        last_name: this.me.last_name,
        email: this.me.email,
        phone_number: this.me.phone_number
      }
    },
    recipient () {
      let rel = this.selectedRelationship
      if (this.recipientId) {
        let client = rel.client
        if (client && client.id) {
          let email = client.email
          let phone = client.phone_number
          return {
            id: rel.id,
            first_name: client.first_name,
            last_name: client.last_name,
            full_name: `${client.first_name} ${client.last_name}`,
            email,
            phone_number: phone
          }
        }
      }
    },
    payload () {
      let data = {
        recipient: this.recipient,
        sender: this.sender,
        message: this.shortMessage,
        preferred_transport: this.messageType
      }
      if (this.messageType === 'Email') {
        data['subject'] = this.subject
        data['message'] = this.message
      }
      return data
    }
  }
}
</script>



// WEBPACK FOOTER //
// Compose.vue?4b448ebc